import css from 'styled-jsx/css';

const styles = css.global`.deposit_with_otp .text_inputs_wrapper{display:flex;column-gap:0.625rem}.deposit_with_otp .text_inputs_wrapper .helper_text{color:var(--error) !important}`;

export default styles;